module.exports = __webpack_public_path__ + "img/loading.ddc9fc2b.gif";